var render = function render(){var _vm=this,_c=_vm._self._c;return _c('app-content-box',{staticClass:"events",class:{'is-loading': _vm.is.loading},attrs:{"title":_vm.title || 'Latest events',"is-grid":4,"icon":"lobbyEvents","blank":true,"not-padded":true}},_vm._l((_vm.amendedCollection),function(event){return _c('app-widget-event',{key:event.id,attrs:{"loading":_vm.is.loading,"event":event,"is-grid":true}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }